import React from 'react';
import { Heart, Users, Sparkles } from 'lucide-react';
import { Reveal } from './Reveal';
import { Section } from './Section';
import styles from './GiftSection.module.css';

const useCases = [
  {
    icon: Heart,
    text: 'Your partner who keeps saying they want to slow down',
    desc: 'Something alive. Something growing. Better than flowers.',
  },
  {
    icon: Users,
    text: 'Parents who could use a quiet morning ritual',
    desc: 'They\'ll think of you every time they check on it.',
  },
  {
    icon: Sparkles,
    text: 'Anyone who deserves more than another gift card',
    desc: 'An experience that keeps returning — every harvest.',
  },
];

interface GiftSectionProps {
  onPrimaryCtaClick: () => void;
}

export function GiftSection({ onPrimaryCtaClick }: GiftSectionProps) {
  return (
    <Section id="gift" title="A Gift That Keeps Growing">
      <div className={styles.layout}>
        <Reveal>
          <div className={styles.left}>
            <p className={styles.intro}>
              Most gifts are opened once.
              This one is experienced every morning — for weeks.
              Every harvest is a small reminder of someone who thought of them.
            </p>
            <p className={styles.introSub}>
              $49. Thoughtfully packaged. Free NYC delivery.
            </p>
            <button type="button" className={styles.cta} onClick={onPrimaryCtaClick}>
              Order as a Gift — $49
            </button>
          </div>
        </Reveal>

        <Reveal delayMs={100}>
          <div className={styles.useCases}>
            {useCases.map((use) => (
              <div key={use.text} className={styles.useCase}>
                <div className={styles.useCaseIconWrap} aria-hidden="true">
                  <use.icon strokeWidth={1.6} />
                </div>
                <div>
                  <p className={styles.useCaseTitle}>{use.text}</p>
                  <p className={styles.useCaseDesc}>{use.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
